import SystemFieldProto from '../../proto/system-field-proto';
import PrioritySelector from '../../../gd-components/priority-selector/priority.jsx';
import SystemFieldPriorityViewInImport from "./components/view-in-import";

export default class PriorityField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.PRIORITY;
    }

    get sortHintMessage() {
        return 'Sort by priority';
    }

    getCsvValue(item) {
        const { companyId, priority} = item;
        let res = priority;
        const priorities = gd.session.companies.get(companyId).priorities;
        if (priorities['priority'+priority]) res = priorities['priority'+priority];
        return res;
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => -i.item.priority],
            directions: [sort]
        }
    }

    getRenderComponent() {
        switch (this.entityType) {
            case gd.const.entityType.PROJECT:
            case gd.const.entityType.TASK:
                return PrioritySelector;
            default:
                throw new Error(this.constructor.name + ': getRenderComponent is not available');
        }
    }

    normalizeCSVValue(value) {

        const priorities = gd.session.companies.get(gd.companyId).priorities;

        let intValue;

        // Try map by number
        intValue = parseInt(value);
        if (intValue && priorities.getName(intValue)) {

            if (priorities["priority"+intValue]) {
                return intValue;
            } else {
                return null;
            }

        }

        // try map by string
        intValue = priorities.getValueByName(value);
        if (intValue) {
            return intValue;
        }

        return null;
    }

    getComponentViewInImport() {
        return SystemFieldPriorityViewInImport;
    }

}
